import React from 'react'
import ReactDOM from 'react-dom/client'

// Fonts ship inside our own build — nothing is fetched from Google (Gavin,
// 17 Sep; Kai, 28 Sep: "replace Google everywhere"). Open Sans is the admin and
// verification prose, IBM Plex Mono the hashes and addresses; the weights are
// the ones the code asks for. The 360 player itself sets Arial.
import '@fontsource/open-sans/300.css'
import '@fontsource/open-sans/400.css'
import '@fontsource/open-sans/600.css'
import '@fontsource/open-sans/700.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'

import App from './App'
import { installDebugConsole } from './system/debugConsole'
import { captureFixtureRequest } from './verification/fixture/fixtureMode'

// Before anything else renders: with ?debug=true this captures console output
// and uncaught errors into an on-screen panel that can upload itself to the
// debug paste drop — dev tools for devices that have none (cloud iPhones).
installDebugConsole()

// Also before anything renders: `/video/<id>` re-navigates to `/video/<slug>`
// and drops the incoming query string on the way, so `?verify=fixture` has to
// be read here or not at all. See fixture/fixtureMode.ts.
captureFixtureRequest(window.location.search)

let render = () => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  root.render(
    <>
      <App />
    </>
  )
}

render()